module.exports = __webpack_public_path__ + "static/media/plomeria-ico.26a2d524.svg";